<template>
  <div class="product">

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="" label="日期">
              <template slot-scope="scope">
                {{scope.row.date_time_text}}
              </template>
            </el-table-column>
            <el-table-column prop="money" label="累计奖金"></el-table-column>
            <el-table-column prop="log_type" label="类别">
              <template slot-scope="scope">
                <span class="gray" v-if="scope.row.log_type == 10">单品奖金池</span>
                <span class="green" v-if="scope.row.log_type == 20">礼包奖金池</span>
              </template>
            </el-table-column>
            <el-table-column prop="dec_money" label="当日减免金额"></el-table-column>
            <el-table-column prop="resolve_total" label="当日发放份数"></el-table-column>
        
            <el-table-column prop="is_settled" label="状态">
              <template slot-scope="scope">
                <span class="gray" v-if="scope.row.is_settled == 0">待发放</span>
                <span class="green" v-if="scope.row.is_settled == 1">已发放</span>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button v-if="scope.row.is_settled==0" @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
            </template>
          </el-table-column>
          </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="formModel"  @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>

<script>
  import BonusApi from '@/api/weightbonus.js';
  import Edit from './dialog/Dailyedit.vue';
  export default {
    components: {
      /*编辑组件*/
      Edit
    },
    data() {
      return {
        //加载
        loading: true,// true 为加载中   false 加载结束

        // 选项卡控制
        activeName: 'all',

        //搜索控制
        searchForm: {
        },

        //表格数据
        tableData: [],/*列表数据*/
        totalDataNumber: 0,/*总条数*/
        pageSize: 20,/*一页多少条*/
        curPage: 1,/*当前是第几页*/


        /*是否打开添加弹窗*/
        open_add: false,
        open_edit: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },
        /*省市区*/
        areaList: [],

      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
       // 选项卡 start
       handleClick(tab, event) {
         /*切换选项卡 */
         let self = this;
         self.curPage = 1; //变为第一页
         self.loading = true;//加载中
         self.activeName = tab.name;
         self.getData(); //获取数据
       },
       // 选项卡 end


       /*搜索查询*/
       onSubmit() {
         let self = this;
         self.loading = true;//加载中
         self.getData();//获取数据
       },

      //列表数据 start

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val; //选择的页数
        self.loading = true; //加载中
        self.getData();//获取数据
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;  //调到第一页
        this.pageSize = val; //每页多少条
        this.getData(); //获取数据
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        // Params = self.searchForm; //搜索
        Params.page = self.curPage; //当前页数
        Params.list_rows = self.pageSize;//每页多少条

        //请求接口
        BonusApi.getDailyList(Params, true).then(res => {

          self.loading = false;//加载结束
          self.tableData = res.data.list.data; //把数据给列表
          self.totalDataNumber = res.data.list.total;//一共多少条

        }).catch(error => {
          self.loading = false; //加载结束
        });
      },

      //列表数据 end


      /*删除*/
      delClick: function(row) {
        let self = this;
        self.loading = true;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          BonusApi.del({
            settlement_id: row.settlement_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          }).catch(() =>{
            self.loading = false;
          });
        }).catch(() =>{
          self.loading = false;
        });
      },

      //操作 end
      /*打开添加*/
      addClick() {
        this.Oneform.model = {};
        this.Oneform.type = 'add';
        this.open_add = true;
      },
      //编辑
     /*打开编辑*/
    editClick(item) {
      this.formModel = item;
      this.open_edit = true;
    },
      detailClick(row) {
        let settlement_id = row.settlement_id;
        this.$router.push({
          path: '/weightbonus/bonus/detail',
          query: {
            settlement_id: settlement_id
          }
        })
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.open_add = e.openDialog;
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/weightbonus/bonus/daily.vue